import { useStore, useStoreMap } from 'effector-react'
import { mainBalance } from '~/entities/MainBalance'
import { CURRENCY } from '~/shared/config/constants'
import { ArrowRightIcon, PlusIcon } from '~/shared/ui/icons'
import { ProgressBlock } from '~/shared/ui/Loaders'
import {
  TitleWrapper,
  ActionsWrapper,
  Title,
  Balance,
  Currency,
  Button,
} from './staled'

type BalanceHeadingProps = {
  onPayout: () => void
  onPay: () => void
}

export function BalanceHeading({ onPayout, onPay }: BalanceHeadingProps) {
  const isPending = useStore(mainBalance.getCurrentBalanceFx.pending)

  const amount = useStoreMap(
    mainBalance.$currentBalance,
    (currentBalance) => currentBalance?.getAmount() || 0,
  )

  if (isPending) return <ProgressBlock height={158} />

  return (
    <div>
      <TitleWrapper>
        <Title>Мой баланс</Title>
        <Balance>
          {amount.toLocaleString()}&#x20;
          <Currency>{CURRENCY}</Currency>
        </Balance>
      </TitleWrapper>
      <ActionsWrapper>
        <Button
          fullWidth
          style={{ marginRight: '8px' }}
          contentProps={{ style: { padding: '8px 24px' } }}
          startDecorator={<ArrowRightIcon />}
          variant='aliceBlueFlooded'
          onClick={onPayout}
        >
          Вывести
        </Button>
        <Button
          style={{ marginLeft: '8px' }}
          fullWidth
          startDecorator={<PlusIcon />}
          contentProps={{ style: { padding: '8px 24px' } }}
          variant='aliceBlueFlooded'
          onClick={onPay}
        >
          Пополнить
        </Button>
      </ActionsWrapper>
    </div>
  )
}
